import { Component, OnInit } from '@angular/core';
import { DocumentModel } from '../../../../shared/models/document.model';
import { NumberPipe } from '../../../../shared/pipe/number.pipe';
import { AbreCuentasService } from '../../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';

@Component({
  selector: 'app-back-document-info',
  templateUrl: './back-document-info.component.html',
  styleUrls: ['./back-document-info.component.scss'],
})

/**
 * Summary  The component to Back Document info view
 */
export class BackDocumentInfoComponent implements OnInit {
  documentInfo: DocumentModel;
  /**
   * Summary Constructor by defintion of services and charge Document Info
   * @param abrecuentasService
   */
  constructor(
    public copyService: CopyService,
    private abrecuentasService: AbreCuentasService,
    private numberPipe: NumberPipe,
  ) {

  }

  ngOnInit() {
    this.documentInfo = this.abrecuentasService.getDocumentInfo();
  }

  /**
   * Función para transformar las cedulas con el punto de separación
   *
   * *Function to transform IDs with the point of separation*
   *
   * @type {function}
   * @param {string} text
   * @returns {string}
   */
  getTransformedDocument = (text: string): string => this.numberPipe.transform(text, 'document', '.');

}
